import React, { useState } from 'react';

export function OfficialLink({ href, children, className = '' }) {
    return (
        <a className={`legal-board-link ${className}`} href={href} target="_blank" rel="noopener noreferrer">
            {children}
            <i className="fas fa-external-link-alt legal-board-link-icon" aria-hidden="true"></i>
        </a>
    );
}

export function DateForm({ id, label, withReference = false, referenceLabel = 'Número de registre (opcional)', submitLabel, busy, onSubmit, onCancel }) {
    const [date, setDate] = useState('');
    const [reference, setReference] = useState('');
    return (
        <div className="legal-board-inline-form">
            <div className="legal-board-field">
                <label htmlFor={`${id}-date`}>{label}</label>
                <input id={`${id}-date`} type="date" value={date} onChange={(event) => setDate(event.target.value)} disabled={busy} />
            </div>
            {withReference ? (
                <div className="legal-board-field">
                    <label htmlFor={`${id}-reference`}>{referenceLabel}</label>
                    <input id={`${id}-reference`} type="text" value={reference} onChange={(event) => setReference(event.target.value)} disabled={busy} />
                </div>
            ) : null}
            <div className="legal-board-inline-form-actions">
                <button type="button" className="legal-board-button primary" onClick={() => onSubmit({ date, reference })} disabled={busy || !date}>{submitLabel}</button>
                <button type="button" className="legal-board-button link" onClick={onCancel} disabled={busy}>Cancel·lar</button>
            </div>
        </div>
    );
}

export function NoteForm({ id, label, submitLabel, busy, onSubmit, onCancel }) {
    const [note, setNote] = useState('');
    return (
        <div className="legal-board-inline-form">
            <div className="legal-board-field">
                <label htmlFor={`${id}-note`}>{label}</label>
                <textarea id={`${id}-note`} rows={2} value={note} onChange={(event) => setNote(event.target.value)} disabled={busy} />
            </div>
            <div className="legal-board-inline-form-actions">
                <button type="button" className="legal-board-button primary" onClick={() => onSubmit({ note })} disabled={busy}>{submitLabel}</button>
                <button type="button" className="legal-board-button link" onClick={onCancel} disabled={busy}>Cancel·lar</button>
            </div>
        </div>
    );
}

/**
 * One screen of a step-by-step flow: «← Tornar» leaves it, a thin bar and
 * «Pas X de N» say where you are, and «Enrere» / «Següent» move along.
 */
export function StepScreen({ id, title, step, total, onExit, onBack, onNext, nextLabel = 'Següent', nextIcon = null, nextDisabled = false, busy = false, children }) {
    return (
        <section className="legal-board-card public-utility-step-screen" aria-labelledby={`${id}-title`}>
            <div className="public-utility-step-screen-top">
                <button type="button" className="legal-board-button link" onClick={onExit} disabled={busy}>← Tornar</button>
                <span className="legal-board-muted legal-board-small">Pas {step} de {total}</span>
            </div>
            <div className="public-utility-progress" aria-hidden="true"><span style={{ width: `${Math.round((step / total) * 100)}%` }}></span></div>
            <h2 id={`${id}-title`}>{title}</h2>
            {children}
            {onBack || onNext ? (
                <div className="public-utility-step-screen-foot">
                    {onBack ? <button type="button" className="legal-board-button link" onClick={onBack} disabled={busy}>Enrere</button> : <span></span>}
                    {onNext ? (
                        <button type="button" className="legal-board-button primary" onClick={onNext} disabled={busy || nextDisabled}>
                            {nextIcon ? <i className={`fas ${nextIcon}`} aria-hidden="true"></i> : null} {nextLabel}
                        </button>
                    ) : null}
                </div>
            ) : null}
        </section>
    );
}
